import { render } from "./devices.harvesterhci.io.sriovgpudevice.vue?vue&type=template&id=cf46bef4"
import script from "./devices.harvesterhci.io.sriovgpudevice.vue?vue&type=script&lang=js"
export * from "./devices.harvesterhci.io.sriovgpudevice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__